import styled from "styled-components";

import LordImg from "./img/transclasses/lord.gif"
import HighPriestImg from "./img/transclasses/highpriest.gif"
import HighWizzardImg from "./img/transclasses/highwizzard.gif"
import WhiteSmithImg from "./img/transclasses/whitesmith.gif"
import SniperImg  from "./img/transclasses/sniper.gif"
import CrossImg  from "./img/transclasses/cross.gif"

import PaladinImg from "./img/transclasses/paladin.gif"
import ChampImg from "./img/transclasses/champ.gif"
import ProfessorImg from "./img/transclasses/professor.gif"
import DesorderImg from "./img/transclasses/desorder.gif"
import ChemistImg from "./img/transclasses/chemist.gif"
import MenestrelImg  from "./img/transclasses/menestrel.gif"
import CiganImg  from "./img/transclasses/cigan.gif"

function TransClassQuests() {
    return(<>
        <ClassListContainer>
            <TitleContainer>Classes T - 1</TitleContainer>
            <ClassListItem>
                <ClassListIcon iconImage={LordImg}/>
                <ClassListDescription>Lorde </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={HighPriestImg}/>
                <ClassListDescription>Sumo-Sacerdote </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={HighWizzardImg}/>
                <ClassListDescription>Arquimago </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={WhiteSmithImg}/>
                <ClassListDescription>Mestre-Ferreiro </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={SniperImg}/>
                <ClassListDescription>Atirador de Elite </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={CrossImg}/>
                <ClassListDescription>Algoz </ClassListDescription>
            </ClassListItem>
        </ClassListContainer>

        <ClassListContainer>
            <TitleContainer>Classes T - 2</TitleContainer>
            <ClassListItem>
                <ClassListIcon iconImage={PaladinImg}/>
                <ClassListDescription>Paladino </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={ChampImg}/>
                <ClassListDescription>Mestre</ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={ProfessorImg}/>
                <ClassListDescription>Professor </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={DesorderImg}/>
                <ClassListDescription>Desordeiro </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={ChemistImg}/>
                <ClassListDescription>Criador </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={MenestrelImg}/>
                <ClassListDescription>Menestrel </ClassListDescription>
            </ClassListItem>
            <ClassListItem>
                <ClassListIcon iconImage={CiganImg}/>
                <ClassListDescription>Cigana </ClassListDescription>
            </ClassListItem>
        </ClassListContainer>

    </>
    )
}

const TitleContainer = styled.h1`

`

const ClassListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 30px 0;
`

const ClassListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    padding: 8px;
    margin: 2px 0;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

     &:hover {
        background-color: rgba(9, 78, 142, 1);
        color: white;
        scale: 1.2;
    }
`

const ClassListIcon = styled.div`
    background-image: url(${props => props.iconImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    //border: solid 1px rgba(0,0,0,1)
`

const ClassListDescription = styled.span`
    width: 200px;
    height: 25px;
`



export default TransClassQuests;